const NotificationTemplateTypeEnum = Object.freeze({
    INVESTORS: 'investors',
    USERS: 'users'
});

export default NotificationTemplateTypeEnum;
